import React, { memo } from 'react';
import { Grid, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Search, Close } from '@mui/icons-material';
import { TextField } from '@totalsoft/rocket-ui';

const StateTransitionListFiltersComponent = ({ listFilter, onListFilterChanged }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} justifyContent='flex-end'>
      <Grid item xs={6} sm={6} md={6}>
        <TextField
          fullWidth
          label={t('DocumentTypes.DocumentWithStateTransitions.Transition')}
          value={listFilter.transitionFilter}
          onChange={e => onListFilterChanged('transitionFilter', e)}
          startAdornment={<Search />}
          endAdornment={
            <Tooltip title={t('Tooltips.ResetFilters')}>
              <IconButton onClick={() => onListFilterChanged('transitionFilter', '')}>
                <Close />
              </IconButton>
            </Tooltip>
          }
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6}>
        <TextField
          fullWidth
          label={t('UserGroups.Title')}
          value={listFilter.userGroupFilter}
          onChange={e => onListFilterChanged('userGroupFilter', e)}
          startAdornment={<Search />}
          endAdornment={
            <Tooltip title={t('Tooltips.ResetFilters')}>
              <IconButton onClick={() => onListFilterChanged('userGroupFilter', '')}>
                <Close />
              </IconButton>
            </Tooltip>
          }
        />
      </Grid>
    </Grid>
  );
};

StateTransitionListFiltersComponent.propTypes = {
  onListFilterChanged: PropTypes.func.isRequired,
  listFilter: PropTypes.object.isRequired
};

export default memo(StateTransitionListFiltersComponent);
